angular.module('impactx.rfx').controller('RFXBuyerListCtrl', [
    '$scope',
    '$redirect',
    'selectedListItems',
    'RFXBuyerService',
    'RFXCreateService',
    'dataGen',
    '$mdDialog',
    '$route',
    'ConfirmationService',
    'ToastService',
    'TranslationService',
    RFXBuyerListCtrl
]);

function RFXBuyerListCtrl($scope, $redirect, selectedListItems, RFXBuyerService, RFXCreateService, dataGen, $mdDialog,
                          $route, ConfirmationService, ToastService, TranslationService) {

    var self = this;
    self.$onInit = function() {
        self.conversation = $scope.trns.conversation;
        self.unreadConversation = $scope.trns.unreadConversation;
    }

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'RFXView'
        },
        {
            label: "offers",
            linkFunction: getRFXOfferLink,
            type: 'link',
            condition: canViewOffers,
            process: 'RFXView'
        },
        {
            label: "openOffers",
            type: 'dialogaction',
            action: openOffers,
            condition: canOpenOffers
        },
        {
            label: "enterCode",
            type: 'dialogaction',
            action: enterCode,
            condition: canEnterCode
        },
        {
            label: "delete",
            type: 'dialogaction',
            action: deleteRFQH,
            condition: canDeleteRFQH
        },
        {
            label: "supplierRecommendation",
            linkFunction: getSupplierRecommendationLink,
            type: 'link',
            condition: canViewSupplierRecommendation
        }
    ];

    this.createRFX = function () {
        RFXCreateService.createRFX("all", 0);
    };

    this.meta = {
        rowTemplate: 'modules/rfx/templates/rfxbuyerlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/rfx/buyer/list',
        id: "rfxlistbuyer",
        buttonDefinition: buttonDefinition,
        mainActionFunction: {id: "new", action: this.createRFX, icon: "mdi-plus"}
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "rfxbuyer/" + selectedListItems.getFirstSelectedId();
    }

    function getRFXOfferLink() {
        return "rfx/offers/" + selectedListItems.getFirstSelectedId();
    }

    function openOffers(event) {
        RFXBuyerService.openOffers(event, selectedListItems.getFirstSelectedId());
    }

    function enterCode(event, trns) {
        $mdDialog.show({
            controller: "EnterOffercodeCtrl",
            controllerAs: "enterOffercodeCtrl",
            templateUrl: "modules/basket/templates/enteroffercode.tmpl.html",
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                trns: trns
            }
        }).then(function (addedToBasket) {
            if (addedToBasket) {
                $redirect.redirectTo(null, "/basket")
            }
            else {
                $route.reload();
            }
        });
    }

    function canViewOffers() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canViewOffers.value;
    }

    function canDeleteRFQH() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().canDeleteRFQH.value;
    }

    function deleteRFQH(event) {
        ConfirmationService.showConfirmationDialog(function () {
            dataGen.postAsForm({}, {rfqhId: selectedListItems.getFirstSelectedId()}, "/rfx/buyer/delete").then(function () {
                ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
                $redirect.reload();
            });
        }, event, TranslationService.get('confirmDelete'), TranslationService.get('delete'), TranslationService.get('abort'));
    }

    function canOpenOffers() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return selectedListItems.isSingleSelection && firstSelectedItem && firstSelectedItem.canOpenOffers.value;
    }

    function canEnterCode(additionalFields) {
        if(selectedListItems.isNoSelection() && additionalFields) {
            return additionalFields.canEnterCode;
        }
        return false;
    }

    function canViewSupplierRecommendation() {
        return selectedListItems.isSingleSelection() && selectedListItems.getFirstSelectedItem().supplierRecommendationId.value > 0;
    }

    function getSupplierRecommendationLink() {
        var firstSelectedItem = selectedListItems.getFirstSelectedItem();
        return "rfx/offer/" + firstSelectedItem.supplierRecommendationId.value;
    }

}